export default "__VITE_ASSET__BuLr$fwi__"